// Note - for ease of build, this is pre-transpiled.  Make sure any changes that you add comply

/**
 * 
 * @example 
 * <caption>Below is a typical example that avoids doing: `onClick={() => this.props.doSomething(i.id)}` ,which triggers an eslint warning for no arrow functions inside of JSX attributes</caption>
 * 
 * import callWith from '@os/call-with';
 * 
 * class Foo extends Component {
 *
 *   explicitArgsOnly = (x) => this.props.doSomething(x);
 *   
 *   explicitPlusCallback = (x, e) => this.props.doSomething(x, e);
 *
 *   render({items}) {
 *     return (
 *       <ul>
 *         { items.map(i => 
 *             <li><a href={i.href} onClick={callWith(this.explicitArgsOnly, i.id)} onDblClick={callWith(this.explicitPlusCallback, i.id, true)}/></li>    
 *         )}
 *       </ul>
 *     )
 *   }
 * }
 *
 * @param {Function} fn function to call when the return value is invoked
 * @param {*} [arg] Argument to pass to fn when it is invoked
 * @param {Boolean} [passCallingArgs=false] If `true`, any arguments passed to the returned function will be called as the last arguments to fn
 * @returns {Function} The cached function reference that will invoke fn with arg, and optionally the arguments sent to the cached function when called
 */
function callWith(fn, arg, passCallingArgs) {
	if (!fn) return;
	var cache = fn.__callWithCache || (fn.__callWithCache = []);
	for (var i = cache.length; i--;) {
		var cached = cache[i];
		if (cached.arg === arg) return cached.proxy;
	}
	var proxy = passCallingArgs ? function () {
		for (var _len = arguments.length, rest = Array(_len), _key = 0; _key < _len; _key++) {
			rest[_key] = arguments[_key];
		}

		return fn.apply(undefined, [arg].concat(rest));
	} : function () {
		return fn(arg);
	};
	cache.push({ arg: arg, proxy: proxy });
	return proxy;
}

module.exports = callWith;